<template>
    <section class="bg-white dark:bg-gray-900">
   <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-6">
       <div class="mx-auto mb-8 max-w-screen-sm lg:mb-16">
           <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">Explore the Archives</h2>
           <p class="font-light text-gray-500 sm:text-xl dark:text-gray-400">work in progress</p>
       </div> 
       <div class="grid gap-8 lg:gap-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
           <div class="text-center text-gray-500 dark:text-gray-400">
            <router-link :to="{name:'mediaRoll', params: { albumid: 'lifetime'}}">
               <img class="mx-auto mb-4 w-36 h-36 rounded-full transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="..\assets\lifetime\Lifetime1.jpg" alt="Bonnie Avatar">
            </router-link> 
               <h3 class="mb-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                   <a href="#">Life Time Fitness </a>
               </h3>
               <p>Laguna Niguel Head Pro and Director</p>             
           </div>
           <div class="text-center text-gray-500 dark:text-gray-400">
                <router-link :to="{name:'mediaRoll', params: { albumid: 'commentator'}}">
                  <img class="mx-auto mb-4 w-36 h-36 rounded-full transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="..\assets\broadcast\broadcast1.jpg" alt="Helene Avatar">
                </router-link> 
               <h3 class="mb-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                   <a href="#">Commentator</a>
               </h3>
               <p>PPA OCC CUP/ Major League Pickleball</p>
                            
           </div>
           <div class="text-center text-gray-500 dark:text-gray-400">
            <router-link :to="{name:'mediaRoll', params: { albumid: 'podiums'}}">
               <img class="mx-auto mb-4 w-36 h-36 rounded-full transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="..\assets\podium\Podium1.jpg" alt="Jese Avatar">
            </router-link>
               <h3 class="mb-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                   <a href="#">Podium</a>
               </h3>
               <p>Victories</p>              
           </div>
           <div class="text-center text-gray-500 dark:text-gray-400">
               <img class="mx-auto mb-4 w-36 h-36 rounded-full transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="..\assets\nike\Nike1.jpg" alt="Joseph Avatar">
               <h3 class="mb-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                   <a href="#">Events</a>
               </h3>
               <p>Nike BootCamp</p>              
           </div>
           <div class="text-center text-gray-500 dark:text-gray-400">
               <img class="mx-auto mb-4 w-36 h-36 rounded-full transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="..\assets\action\action1.jpg" alt="Sofia Avatar">
               <h3 class="mb-1 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                   <a href="#">Action Shots</a>
               </h3>
               <p></p>             
           </div>   
          
         
       </div>  
   </div>
 </section>
     
 </template>
 
 
 <script>
 import { initTooltips, initDropdowns  } from "flowbite"
 import {onMounted, ref} from 'vue'
 
 
 export default {
     setup(){
         const dropDowner = ref(['mario', 'lugio', 'peach'])
         const memberTest = ref([
             {id: 1, first: 'billy', last: 'gaonzo', email: 'ger@gmail.com'},            
             {id: 2, first: 'bozo', last: 'sfeged', email: 'gdfeer@gmail.com'}
         ])
         
         const keymaster = Object.keys(memberTest.value[0])
         onMounted(() => {
             
         });
         const goToProfile = (idkey)=>{
            router.push({            
                name:'album',  params: { albumid: idkey  }
          })
           
        }
         
 
         // onMounted(()=>{ initTooltips(), initDropdowns();})
 
         return {dropDowner, memberTest, goToProfile}
     }    
 }
 </script>
 
 <style>
 
 </style>